// frontend/src/features/citysense/housing-stock-modeller/components/TabBar.tsx

import React from "react";
import { ViewMode } from "../types";
import { Home, TrendingUp, Zap, BookOpen } from "lucide-react";

interface Props {
  activeMode: ViewMode;
  onModeChange: (mode: ViewMode) => void;
}

export const TabBar: React.FC<Props> = ({ activeMode, onModeChange }) => {
  const tabs: {
    mode: ViewMode;
    label: string;
    icon: React.FC<{ className?: string }>;
  }[] = [
    { mode: "scenario", label: "Scenario Modelling", icon: Home },
    { mode: "deprivation", label: "Deprivation Index", icon: TrendingUp },
    { mode: "optimizer", label: "Optimizer", icon: Zap },
    { mode: "reference", label: "Reference Table", icon: BookOpen },
  ];

  return (
    <div className="bg-white border-b-2 border-gray-200 px-6">
      <div className="max-w-7xl mx-auto flex gap-2">
        {tabs.map(({ mode, label, icon: Icon }) => {
          const isActive = activeMode === mode;
          return (
            <button
              key={mode}
              onClick={() => onModeChange(mode)}
              className={`flex items-center gap-2 px-6 py-3 font-semibold text-sm border-b-4 transition-all ${
                isActive
                  ? "border-teal-600 text-teal-700 bg-teal-50"
                  : "border-transparent text-gray-600 hover:text-teal-600 hover:bg-gray-50"
              }`}
            >
              <Icon className="w-5 h-5" />
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
};